<app-event-content [event]="node"></app-event-content>
